(function ($) {
  $(document).ready(function () {

    // deodorant-spray
    if($('.product__title h1').attr('rel') == 8719291384098 || $('#QuickAdd-8719291384098').attr('open') || $('#Badge--8719291384098').length > 0 || $('.product__title h1').attr('rel') == 10373223153954 || $('#QuickAdd-10373223153954').attr('open') || $('#Badge--10373223153954').length > 0 || $('.product__title h1').attr('rel') == 10440355971362 || $('#QuickAdd-10440355971362').attr('open') || $('#Badge--10440355971362').length > 0){

      // URL 쿼리스트링을 ?variant= 대신 ?option=옵션명 형태로 관리
      var OPTION_PARAM = 'option';
      var initOption = new URLSearchParams(location.search).get(OPTION_PARAM);

      function setOptionParam(value) {
        var url = new URL(window.location.href);
        url.searchParams.delete('variant');
        // Shopify 검색/추천 결과 클릭 시 붙는 추적 파라미터 제거 (페이지 로드 시 이미 기록됨)
        ['_pos', '_sid', '_ss', '_psq', '_fid', '_v'].forEach(function (key) {
          url.searchParams.delete(key);
        });
        if (value) url.searchParams.set(OPTION_PARAM, value);
        else url.searchParams.delete(OPTION_PARAM);
        window.history.replaceState({}, '', url);
      }

      // ?option= 값으로 진입 시 박스 수 + 향 개수 복원 (자동 장바구니 담기는 하지 않음)
      function restoreOption(value) {
        var parts = value.split(' - ');
        var boxLabel = parts[0].trim();
        var $label = $('.custom_option label').filter(function () {
          return $(this).find('p strong').text().trim() === boxLabel;
        });
        if (!$label.length) return false;

        $label.trigger('click'); // 박스 수 선택 → 기존 change 핸들러 실행

        if (parts[1]) {
          setTimeout(function () {
            var inputs = { 'Aqua Bloom': '#c_input1', 'Sweet Berry': '#c_input2', 'Soft Cotton': '#c_input3' };
            var sum = 0;
            parts[1].split('/').forEach(function (seg) {
              var m = seg.trim().match(/^(.*)\s(\d+)$/);
              if (m && inputs[m[1]]) {
                $(inputs[m[1]]).val(m[2]);
                sum += Number(m[2]);
              }
            });

            var $variant = $('input[name^="Deodorant Spray-1"]').filter(function () {
              return $(this).val().includes(value);
            }).first();
            if ($variant.length) {
              $variant.prop('checked', true);
              $variant.get(0).dispatchEvent(new Event('change', { bubbles: true }));
            }

            $('.c_input').attr('disabled', true).addClass('off');
            $('.option_select_comp').addClass('on select_fin');
            $('.max_txt').html("<div>Please select " + sum + " items. <span style='color:red'>(" + sum + "/" + sum + ")</span></div>");
            setOptionParam(value);
          }, 400); // 기존 change 핸들러의 200ms 처리 이후에 실행
        }
        return true;
      }

      //$('.product-custom-message').removeClass('displaynone');
      if(!($('.product__title h1').attr('rel') == 10440355971362 || $('#QuickAdd-10440355971362').attr('open') || $('#Badge--10440355971362').length > 0)) {
        setTimeout(function(){
          if (initOption && restoreOption(initOption)) return; // 추가: ?option= 으로 진입 시 복원
          $('.product-form__input input[type=radio]').attr("checked", false);
          $('.product-form__input input[name="Deodorant Spray Custom"]:nth-of-type(4) + label').trigger('click');
          var $firstRadio = $('input[name*="Deodorant Spray-1"][value*="6 Boxes"]').first();          
          $firstRadio.prop('checked', true);
          
          $firstRadio.get(0).dispatchEvent(new Event('change', { bubbles: true }));
        },600);
      } else {
        setTimeout(function(){
          if (initOption && restoreOption(initOption)) return; // 추가: ?option= 으로 진입 시 복원
          var $firstRadio = $('.product-form__input input[name="Deodorant Spray Custom"]:nth-of-type(1)');
          $firstRadio.prop('checked', true);
        },600)
      }
      
      $('.product variant-selects').addClass('displaynone');
      setInterval(function(){         
          $('.product variant-selects').hide();       
      },500)

      $('body').prepend('<div class="option_data displaynone"></div>')
      $('.product variant-selects').after(`
      <fieldset class="js product-form__input product-form__input--pill custom_option">
          <input type="radio" id="1box" name="Deodorant Spray Custom"><label for="1box"><div class="prd_vari_price"><strong class="unit_price" rel="$15.99" data="15.99" cp="40.00" valid=""><span class="metafield-money">$15.99</span><i class="fs12">Per box</i></strong><p><strong class="">1 Box</strong></p></div><span class="option_desc save_per_0"><b>Original Price</b></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_233.png?v=1761704855" alt="" class="vari_image"></div></label>
          <input type="radio" id="2box" name="Deodorant Spray Custom"><label for="2box"><div class="prd_vari_price"><strong class="unit_price" rel="$29.98" data="29.98" cp="80.00" valid=""><span class="metafield-money">$14.99</span><i class="fs12">Per box</i></strong><p><strong class="">2 Boxes</strong></p></div><span class="option_desc" sku_code="2"><b>SAVE $8</b><i>25%</i></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_231.png?v=1761704856" alt="" class="vari_image"></div></label>
          <input type="radio" id="3box" name="Deodorant Spray Custom"><label for="3box"><div class="prd_vari_price"><strong class="unit_price" rel="$38.97" data="38.97" cp="120.00" valid=""><span class="metafield-money">$12.99</span><i class="fs12">Per box</i></strong><p><strong class="">3 Boxes</strong></p></div><span class="option_desc" sku_code="3"><b>SAVE $17</b><i>35%</i></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_267.png?v=1761704855" alt="" class="vari_image"></div><span class="option_badge" rel="Most Popular">Most Popular</span></label>
          <input type="radio" id="6box" name="Deodorant Spray Custom"><label for="6box"><div class="prd_vari_price"><strong class="unit_price" rel="$71.94" data="71.94" cp="240.00"  valid=""><span class="metafield-money">$11.99</span><i class="fs12">Per box</i></strong><p><strong class="">6 Boxes</strong></p></div><span class="option_desc" sku_code="6"><b>SAVE $38</b><i>40%</i></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_234.png?v=1761704855" alt="" class="vari_image"></div><span class="option_badge" rel="Best Value">Best Value</span><span class="option_badge free">FREE SHIPPING</span></label>
      </fieldset>
      `);
      $('.custom_option').after(`
        <div class="option_select c_opts">
          <div>
            <span class="aqua">Aqua Bloom</span><div class="input_wrap"><input name="c_opt1" id="c_input1" class="c_input" type="number" min="0" max="2" placeholder="0" value="0" numberonly="" readonly=""><div class="inc count">+</div><div class="dec count">-</div></div>
          </div>
          <div>
            <span class="berry">Sweet Berry</span><div class="input_wrap"><input name="c_opt2" id="c_input2" class="c_input" type="number" min="0" max="2" placeholder="0" value="0" numberonly="" readonly=""><div class="inc count">+</div><div class="dec count">-</div></div>
          </div>
          <div>
            <span class="cotton">Soft Cotton</span><div class="input_wrap"><input name="c_opt3" id="c_input3" class="c_input" type="number" min="0" max="2" placeholder="0" value="0" numberonly="" readonly=""><div class="inc count">+</div><div class="dec count">-</div></div>
          </div>
          <p class="max_txt"></p>
        </div>
      `);

      $('.product-form__buttons').prepend('<div class="option_select_comp"><b>SELECT</b></div>');
      $('.product-form__buttons').css({'position':'relative'})
      
      $(".count").click(function() {   
          $('.c_input').removeClass('off');
          var $button = $(this);
          var oldValue = $button.parent().find("input").val();

          if ($button.text() == "+") {
              var newVal = parseFloat(oldValue) + 1;
              if(oldValue == 1 && $('.c_opts').hasClass('c_opts1')){
                var newVal = parseFloat(oldValue); 
              }
          } else {
              if (oldValue > 0) {
                  var newVal = parseFloat(oldValue) - 1;
              } else {
                  newVal = 0;
              }
          }

          $button.parent().find("input").val(newVal);

          var sum = 0;
          $('.c_input').each(function(){
              sum += Number($(this).val());
          });

          // 선택한 옵션 개수 출력
          var opt_max = 0;
          var opt_max_basic = 0;
          var opt_max_add = 0;
          setTimeout(function(){
            if($('.c_opts').hasClass('c_opts1')){
              opt_max = 1;
              opt_max_basic = 1;
            }else if($('.c_opts').hasClass('c_opts2')){
              opt_max = 2;
              opt_max_basic = 2;
            }else if($('.c_opts').hasClass('c_opts3')){
              opt_max = 3;
              opt_max_basic = 3;
            }else if($('.c_opts').hasClass('c_opts4')){
              opt_max = 6;
              opt_max_basic = 6;
            }

            var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span class='red' style='color:blue'>("+sum+"/"+opt_max_basic+")</span></div>";
            
            if(sum == opt_max_basic){            
              var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span class='red' style='color:red'>("+opt_max_basic+"/"+opt_max_basic+")</span></div>";
              $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').hide();
            }
            if(sum >= opt_max_basic && sum <= opt_max){            
              var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:red'>("+opt_max_basic+"/"+opt_max_basic+")</span></div>";
              $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').hide();
            }
            if(sum == opt_max){            
              var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:red'>("+opt_max_basic+"/"+opt_max_basic+")</span></div>";       
              $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').show();
            }
            if(sum > (opt_max_basic + opt_max_add) ){            
              var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:blue'>("+0+"/"+opt_max_basic+")</span></div>";
              $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').hide();
            }
            $('.max_txt').html(opt_max_txt);
          },200)
          // //선택한 옵션 개수 출력   

          if($('.c_opts').hasClass('c_opts1')){
              if(sum == 1){
                  $('.c_input').attr('disabled',true);
                  $('.option_select_comp').addClass('on');
              }else if(sum > 1){
                  $('.c_input').val(0);
                  $(this).parent().find('input').val(1);
                  $('.option_select_comp').removeClass('on');
                  setTimeout(function(){
                    sum = 1;
                    opt_max_txt = "<div>Please select "+opt_max+" items. <span class='red' style='color:red'>("+sum+"/"+opt_max+")</span></div>";
                    $('.option_select_comp').addClass('on').addClass('select_fin');
                  },150)
              }else if(sum < 1){
                  $('.option_select_comp').removeClass('on').removeClass('select_fin');
              }     
          }else if($('.c_opts').hasClass('c_opts2')){
            if(sum == 2){
                $('.c_input').attr('disabled',true);
                $('.option_select_comp').addClass('on');
            }else if(sum > 2){
                alert('Please select 2 items.');
                $('.c_input').val(0);
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }else if(sum < 2){
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }        
          }else if($('.c_opts').hasClass('c_opts3')){
              if(sum == 3){
                  $('.c_input').attr('disabled',true);
                  $('.option_select_comp').addClass('on');
              }else if(sum > 3){
                  alert('Please select 3 items.');
                  $('.c_input').val(0);
                  $('.option_select_comp').removeClass('on').removeClass('select_fin');
              }else if(sum < 3){
                  $('.option_select_comp').removeClass('on').removeClass('select_fin');
              }        
          }else if($('.c_opts').hasClass('c_opts4')){
              if(sum == 6){
                  $('.c_input').attr('disabled',true);
                  $('.option_select_comp').addClass('on');
              }else if(sum > 6){
                alert('Please select 6 items.');
                $('.c_input').val(0);
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
              }else if(sum < 6){
                  $('.option_select_comp').removeClass('on').removeClass('select_fin');
              }  
          }else{         
            $('.cd_select').hide();
            $(".c_opts td p .button").off('click');
            $('.c_input').attr('disabled',false);     
            $('.c_input').val(0);
            $('.option_select_comp').removeClass('on');
        }   
      });

      $(`input[name="Deodorant Spray Custom"]`).change(function(){    
          var checkedIndex = $(`input[name="Deodorant Spray Custom"]`).index($(`input[name="Deodorant Spray Custom"]:checked`)) + 1;    
          $('.c_input').val(0);                  
          if(!checkedIndex || checkedIndex == '-1'){
              $('.c_opts .dim').show();                
          } else{                
              $('.c_opts .dim').hide();    
              $(".c_opts").removeClass("c_opts-1 c_opts1 c_opts2 c_opts3 c_opts4 c_opts5");
              $('.c_opts').addClass('c_opts'+checkedIndex);
          }         
        
          var opt_max = 0;
          var opt_max_basic = 0;
          var opt_max_add = 0;
          setTimeout(function(){
            if($('.c_opts').hasClass('c_opts1')){
              opt_max = 1;
              opt_max_basic = 1;
            }else if($('.c_opts').hasClass('c_opts2')){
              opt_max = 2;
              opt_max_basic = 2;
            }else if($('.c_opts').hasClass('c_opts3')){
              opt_max = 3;
              opt_max_basic = 3;
            }else if($('.c_opts').hasClass('c_opts4')){
              opt_max = 6;
              opt_max_basic = 6;
            }else{
              opt_max = 0;
              opt_max_basic = 0;
            }
            var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:blue'>("+0+"/"+opt_max_basic+")</span></div>";
            $('.max_txt').html(opt_max_txt);
            $('.option_select_comp').removeAttr('rel');
            $('.option_select_comp').attr('rel', opt_max);
          },200)

          // 박스 수만 바꿔도 즉시 가격(구독가/일회성가) 반영
          var $checked = $(`input[name="Deodorant Spray Custom"]:checked`);
          if ($checked.length) {
            var boxLabel = $checked.next('label').find('p strong').text().trim(); // 예: "3 Boxes", "1 Box"

            var $matchVariant = $('input[name^="Deodorant Spray-1"]').filter(function () {
              return $(this).val().indexOf(boxLabel) === 0; // 박스 수 텍스트로 시작하는 variant 중 첫 번째
            }).first();

            if ($matchVariant.length) {
              $matchVariant.prop('checked', true);
              $matchVariant.get(0).dispatchEvent(new Event('change', { bubbles: true }));

              // 변경: ?variant= 대신 ?option=박스수 로 URL 반영
              setOptionParam(boxLabel);
            }
          }
      })

      $('.option_select_comp').on('click', function() {
        if($(this).hasClass('on')){   
          $('.c_input').addClass('off');
          $(this).addClass('select_fin');

          var c_input1 = $('#c_input1').val() ? $('#c_input1').val() : '0';
          var c_input2 = $('#c_input2').val() ? $('#c_input2').val() : '0';
          var c_input3 = $('#c_input3').val() ? $('#c_input3').val() : '0';   
          var box = $(this).attr('rel');
          if(box > 1){
            var box_fin = $(this).attr('rel')+' Boxes';
          }else{
            var box_fin = $(this).attr('rel')+' Box';
          }

          $('.option_data').html('<span>'+box_fin+' - <span rel="'+c_input1+'">Aqua Bloom '+c_input1+'</span><span rel="'+c_input2+'"><i> / </i>Sweet Berry '+c_input2+'</span><span rel="'+c_input3+'"><i> / </i>Soft Cotton '+c_input3+'</span></span>');  
          $(".option_data span[rel='0']").remove();
          $(".option_data span span:first-child:not([rel='0']) i").remove();
          
          var select_option_fin = $('.option_data > span').text();    
          $('input[name^="Deodorant Spray-1"]').filter(function() {
            return $(this).val().includes(select_option_fin);
          }).each(function() {
              
            $(this).trigger('click');
            $(this).attr("checked", true);
            $(this).next('label').trigger('click');       
          });

          // ?variant= 대신 ?option=최종옵션명 으로 URL 반영
          setOptionParam(select_option_fin);

          // SELECT 클릭 후 2초 뒤 Add to Cart 자동 클릭
          setTimeout(function(){
            var $addToCartBtn = $('.product-form__buttons button[type="submit"], .product-form__buttons button.product-form__submit');
            if ($addToCartBtn.length && !$addToCartBtn.prop('disabled')) {
              $addToCartBtn.trigger('click');
            }
          }, 2000);

        }else{
          var comp_cnt = $(this).attr('rel');
          alert('Please select ' + comp_cnt + ' items.');
        }  
      });

      
    }  
  })
})(jQuery);